/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/heading-has-content */
import { Grid, Skeleton } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import {
  KeyboardArrowDownOutlined,
  KeyboardArrowUpOutlined,
} from "@mui/icons-material";
import useWindowWidth from "../../../../../hooks/useWindowWidth";
import FormulaTooltips from "./FormulaTooltips";
import { FaInfo } from "react-icons/fa";
import axiosProtected from "../../../../../api/config/baseWithToken";
import moment from "moment";
import { useDispatch } from "react-redux";
import AnalyticsChart from "./AnalyticsChart";

export default function DataStatisticsChart({ dates, amount, selectDate, storeOwner, currencySymbol }) {
  const windowWidth = useWindowWidth();
  const [cogsRevenueBalance, setCogsRevenueBalance] = useState(null);
  const [revenueDetails, setRevenueDetails] = useState(null);
  // const [loading, setLoading] = useState(false);
  const [chartLoading, setChartLoading] = useState(false);

  const dummyCustomerData = [
    {
      id: 1,
      title: "Revenue",
      amount: revenueDetails?.totalSale || 0,
      items: revenueDetails?.totalCount || 0,
      percentage: revenueDetails?.percentage || 0,
      dates: revenueDetails?.dates || [],
      totalAmount: revenueDetails?.amount || [],
    },
    {
      id: 2,
      title: "COGS",
      amount: cogsRevenueBalance?.cogs?.totalAmount || 0,
      percentage: cogsRevenueBalance?.cogs?.percentage || 0,
      items: cogsRevenueBalance?.cogs?.perItems || 0,
      dates: cogsRevenueBalance?.cogs?.dates,
      totalAmount: cogsRevenueBalance?.cogs?.amount,
    },
    {
      id: 3,
      title: "Current Balance",
      amount: cogsRevenueBalance?.currentBalance || 0,
      percentage: "-67",
      items: cogsRevenueBalance?.pendingBalance || 0,
    },
  ];

  const dispatch = useDispatch();

  const fetchData = useCallback(async () => {
    try {
      setChartLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const formattedDate = selectDate.toISOString();
      const [revenueResponse, cogsResponse] = await Promise.all([
        axiosProtected.get(
          `/store/revenue?date=${moment(formattedDate).format("YYYY-MM-DD")}`
        ),
        axiosProtected.get(
          `/store/cogs-revenue-balance?date=${moment(formattedDate).format(
            "YYYY-MM-DD"
          )}`
        ),
      ]);

      setRevenueDetails(revenueResponse.data?.result);
      setCogsRevenueBalance(cogsResponse.data?.result);
    } catch (error) {
      console.log(error);
    } finally {
      setChartLoading(false);
    }
  }, [selectDate]);

  useEffect(() => {
    if(!storeOwner){

      fetchData();
    }
  }, [dispatch, fetchData]);

  const fetchSyncedOrders = useCallback(async () => {
    // setLoading(true);
    // await dispatch(syncOrders({ message: "no" }));
    // setLoading(false);
  }, [dispatch]);

  const calculateMismatchedItems = useCallback(() => {
    return (
      cogsRevenueBalance?.cogs?.count !== revenueDetails?.totalCount ||
      !cogsRevenueBalance?.cogs?.count
    );
  }, [cogsRevenueBalance, revenueDetails]);

  useEffect(() => {
    if (calculateMismatchedItems() && !storeOwner) {
      fetchSyncedOrders();
    }
  }, [fetchSyncedOrders, calculateMismatchedItems]);
  return (
    <div>
      <Grid
        container
        spacing={windowWidth <= 1700 ? 2 : 4}
        sx={{ padding: "0 0px 0px 20px" }}
      >
        {dummyCustomerData.map((item) => (
          <Grid item xs={4}>
            <div
              style={{
                borderRadius: "10px",
                padding: windowWidth <= 1500 ? "5px 15px" : "10px 20px",
                background: "#1d0d31",
                color: "white",
                display: "flex",
                justifyContent: "space-between",
                border: "1px solid #1e1532",
                transition: "all 0.3s ease in out",
              }}
            >
              <div style={{ width: "100%" }}>
                <div className="flexbox">
                  <div>
                    {item.title !== "Current Balance" ? (
                      <FormulaTooltips
                        title={item.title}
                        windowWidth={windowWidth}
                        content={
                          item.title === "Revenue" ? (
                            <div>
                              <h6>Revenue = Gross Sales -</h6>
                              <h6>Discounts - Refunds + </h6>
                              <h6>Shipping Charged </h6>
                            </div>
                          ) : (
                            <div>
                              <h6>COGS = Total shipping cost + </h6>
                              <h6>Total product cost </h6>
                            </div>
                          )
                        }
                      />
                    ) : (
                      <h5
                        style={{
                          fontSize: windowWidth <= 1500 ? "16px" : "18px",
                          margin: 0,
                        }}
                      >
                        {item.title}
                      </h5>
                    )}
                  </div>
                  {item.title === "COGS" &&
                  cogsRevenueBalance?.cogs?.totalFailedOrders ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {cogsRevenueBalance?.cogs?.totalFailedOrders > 0 && (
                        <FormulaTooltips
                          title={<FaInfo style={{ fontSize: "12px" }} />}
                          windowWidth={windowWidth}
                          content={
                            <div>
                              <h6>COGS calculation may be subject to </h6>
                              <h6>
                                discrepancies due to{" "}
                                <span style={{ color: "red", fontWeight: 500 }}>
                                  {cogsRevenueBalance?.cogs?.totalFailedOrders}{" "}
                                  failed orders
                                </span>
                              </h6>
                            </div>
                          }
                        />
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    // marginBottom: "10px",
                    opacity: item.title === "Current Balance" ? 0 : 1,
                  }}
                >
                  <h5
                    style={{
                      color: item.percentage < 0 ? "red" : "green",
                    }}
                  >
                    {item.percentage + "%"}
                  </h5>
                  {item.percentage < 0 ? (
                    <KeyboardArrowDownOutlined style={{ color: "red" }} />
                  ) : (
                    <KeyboardArrowUpOutlined style={{ color: "green" }} />
                  )}
                </div>
                <div
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "flex-end",
                  }}
                >
                  <div style={{ width: "50%" }}>
                    {chartLoading ? (
                      <>
                        <Skeleton
                          variant="rounded"
                          height={30}
                          width="100%"
                          sx={{ bgcolor: "grey.900" }}
                        />
                        <h4
                          style={{
                            marginTop: 0,
                            fontSize: windowWidth <= 1500 ? "18px" : "24px",
                            width: "350px",
                            opacity: 0,
                          }}
                        ></h4>
                      </>
                    ) : (
                      <h4
                        style={{
                          marginTop: 0,
                          fontSize: windowWidth <= 1500 ? "18px" : "24px",
                          width: "350px",
                        }}
                      >
                        {item.title === "Revenue" ? currencySymbol : "€"}{item.amount}
                      </h4>
                    )}
                    {chartLoading ? (
                      <Skeleton
                        variant="rounded"
                        height={20}
                        width="100px"
                        sx={{ bgcolor: "grey.900", marginTop: "5px" }}
                      />
                    ) : (
                      <h6
                        style={{
                          margin: "10px",
                          marginLeft: 0,
                          marginBottom: 5,
                          fontSize: windowWidth <= 1500 ? "10px" : "12px",
                          color: "lightgray",
                        }}
                      >
                        {item.title === "Current Balance"
                          ? `€${item.items} pending`
                          : item.title === "COGS"
                          ? `€${item.items} per items`
                          : item.items + " items"}
                      </h6>
                    )}
                  </div>
                  <div style={{ width: "50%" }}>
                    {!chartLoading ? (
                      <AnalyticsChart
                        dates={item.dates ? item.dates : dates}
                        amount={item.totalAmount ? item.totalAmount : amount}
                      />
                    ) : (
                      <div
                        style={{ height: windowWidth <= 1500 ? 60 : 80 }}
                      ></div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
